import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";

/** Lista completa da recusa, sem perder os campos que a pessoa precisa corrigir. */
export function RecordViolations({ violations }: { violations: string[] }) {
  const { t } = useTranslation();
  const summary = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (violations.length) summary.current?.focus();
  }, [violations]);
  if (!violations.length) return null;
  return (
    <div ref={summary} role="alert" tabIndex={-1} className="rounded-md border border-[#d4353c] bg-[#fff5f5] p-3 text-[#b02a31] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#b02a31]">
      <p className="mb-2 flex items-center gap-1.5 text-[12px] font-semibold">
        <AlertTriangle aria-hidden="true" className="h-3.5 w-3.5 shrink-0" />
        {t("{{n}} violation(s)", { n: violations.length })}
      </p>
      <ul className="list-disc space-y-1 pl-5 text-[12px] break-words">
        {violations.map((violation, index) => <li key={index}>{violation}</li>)}
      </ul>
    </div>
  );
}
